import { executeRemote } from "./client";

export async function gqlRequest<T>(
  query: string,
  variables?: Record<string, unknown>,
): Promise<T> {
  return executeRemote<T>(query, variables);
}
